// Human-readable labels for penalty and bonus breakdown keys.
// Only non-zero items are shown in the UI, but we need labels for all
// possible keys so new ones added in the API render cleanly.

export type ScoreBreakdownItem = {
  code: string;
  label: string;
  kind: 'penalty' | 'bonus';
};

export const PENALTY_LABELS: ReadonlyArray<ScoreBreakdownItem> = [
  { code: 'P1', label: 'Cross-Floor Assignment', kind: 'penalty' },
  { code: 'P2', label: 'Over/Undersizing', kind: 'penalty' },
  { code: 'P3', label: 'Open Door Reliance', kind: 'penalty' },
  { code: 'P4', label: 'Heating Undersizing', kind: 'penalty' }
];

export const BONUS_LABELS: ReadonlyArray<ScoreBreakdownItem> = [
  { code: 'B1', label: 'Bedroom Fit', kind: 'bonus' },
  { code: 'B2', label: 'Balanced Distribution', kind: 'bonus' },
  { code: 'B3', label: 'Condenser Redundancy', kind: 'bonus' },
  { code: 'B4', label: 'Low Failure Impact', kind: 'bonus' }
];

// Category sub-score labels for the hover tooltips.
// Keys match the breakdown record keys emitted by the scoring API.
export const CATEGORY_SUB_SCORE_LABELS: Record<
  string,
  Record<string, string>
> = {
  comfortPerformance: {
    HC1: 'Heating Coverage',
    HC2: 'Heating Scenario Fit',
    HC3: 'Heating Modulation',
    HC4: 'Heating Distribution',
    HC: 'Heating Comfort',
    CC1: 'Cooling Coverage',
    CC2: 'Cooling Scenario Fit',
    CC3: 'Cooling Modulation',
    CC4: 'Throw Adequacy',
    CC5: 'Cooling Zone Sizing',
    CC: 'Cooling Comfort',
    HU1: 'Cooling Oversizing Control',
    HU2: 'Inverter Turndown',
    HU3: 'Latent Load Awareness',
    HU4: 'Airflow Range',
    HU: 'Humidity Comfort',
    CP: 'Comfort Total'
  },
  installationDifficulty: {
    I1: 'Line Set Complexity',
    I2A: 'Zones per Condenser',
    I2B: 'Handler Mix',
    I2C: 'Branch Box',
    I2: 'System Complexity',
    I3: 'Electrical Requirements',
    I4: 'Component Count',
    I: 'Installation Total'
  },
  noise: {
    N1: 'Outdoor Noise',
    N2: 'Indoor Noise',
    N: 'Noise Total'
  },
  value: {
    V1: 'Price per BTU',
    V2: 'Efficiency Rating',
    V3: 'Price Competitiveness',
    V: 'Value Total'
  }
};
